import {SmsAutomationActions} from "@torim-app/types";

export const automationsStarts = [
  SmsAutomationActions.BeginWeb,
  SmsAutomationActions.BeginScheduled,
]

export const automationActionsTree = {
  [SmsAutomationActions.BeginWeb]: {
    triggers: [
      SmsAutomationActions.FinishedSchedule,
      SmsAutomationActions.LeftSchedule
    ],
    actions: [
      SmsAutomationActions.SendSMs
    ]
  },
  [SmsAutomationActions.BeginScheduled]: {
    triggers: [
      SmsAutomationActions.CustomerCanceled,
      SmsAutomationActions.CustomerDidntVisit,
      SmsAutomationActions.AmountOfDaysPassed
    ],
    actions: [
      SmsAutomationActions.SendSMs
    ]
  },
};

export const triggersMapping: Record<SmsAutomationActions, { name: string; desc: string }> = {
  [SmsAutomationActions.FinishedSchedule]: {
    name: 'הזמנת תור בהצלחה',
    desc: 'לקוח סיים את כל שלבי זימון התור, ואימת את מספר הטלפון שלו בהצלחה'
  },
  [SmsAutomationActions.LeftSchedule]: {
    name: 'נטישה בהזמנת התור',
    desc: 'לקוח שבעבר הזמין תור, ניסה להזמין תור נוסף אך נטש את התהליך באמצע',
  },
  [SmsAutomationActions.CustomerCanceled]: {
    name: 'ביטול תור',
    desc: 'לקוח הזמין תור, ולאחר שהתור אושר החליט לבטל את התור במסגרת הזמן המאושרת.'
  },
  [SmsAutomationActions.CustomerDidntVisit]: {
    name: 'לקוח לא הגיע הרבה זמן',
    desc: 'לקוח שהזמין מספר תורים בעבר, לא חזר לאחר תקופת זמן - נטישה אפשרית',
  },
  [SmsAutomationActions.BeginWeb]: {
    name: 'התחלת אוטומציה - הגעת לקוח לאתר',
    desc: 'התחלת אוטמציה של מסע לקוח שהמתחיל בכניסה לאתר',
  },
  [SmsAutomationActions.BeginScheduled]: {
    name: 'התחלת אוטומציה - לקוח הזמין תור',
    desc: 'התחלת אוטמציה של מסע לקוח שהמתחיל בהזמנת תור',
  },
  [SmsAutomationActions.SendSMs]: {
    name: 'שליחת הודעת SMS',
    desc: 'שליחת הודעת SMS עם נוסח לבחירתכם',
  },
  [SmsAutomationActions.AmountOfDaysPassed]: {
    name: 'עברו X ימים מהתור',
    desc: 'ללקוח היה ביקור, ועברו X ימים מאז',
  },
};
